<template>
  <div class="header">
    <sf-header>
      <div class="header__container sf-cg sf-fr sf-pv-xs">
        <nuxt-link :to="localePath('index')" class="sf-mr-s">
          <img v-if="showChristmasLogo" :src="require(`~/assets/christmas-logo.png`)" class="header__logo" alt="">
          <logo v-else/>
        </nuxt-link>
        <sf-lang-switch class="header__switch"/>
        <navigation :class="{ hidden: percent }" class="header__nav sf-mh"/>
        <sf-progress
          v-if="percent"
          :value="Number(percent)"
          :total="totalSteps"
          :background-class="'sf-bg-secondary'"
          class="header__progress"
          slim/>
        <login class="header__login"/>
        <burger-menu class="header__mobile-menu" @click="toggleDrawer"/>
      </div>
    </sf-header>
    <sf-drawer v-model="showDrawer" class="drawer">
      <sf-lang-switch class="drawer__switch"/>
      <profile-links class="drawer__profile"/>
      <navigation class="drawer__nav"/>
      <div class="drawer__contacts">
        <sf-contact-link type="tel" name="cc" class="sf-mb-xs"/>
        <sf-contact-link type="email" name="cc"/>
      </div>
    </sf-drawer>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Logo from '~/assets/logo.svg';
import Navigation from '~/components/header/navigation';
import ProfileLinks from '~/components/header/profile-links';
import Login from '~/components/header/login';
import BurgerMenu from '~/components/controls/burger';

export default {
  components: { Navigation, Login, BurgerMenu, ProfileLinks, Logo },
  data: () => ({
    showDrawer: false,
    showChristmasLogo: false,
  }),
  computed: {
    ...mapState('flow', ['percent', 'totalSteps', 'backgroundClass']),
  },
  methods: {
    toggleDrawer() {
      this.showDrawer = !this.showDrawer;
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  position: relative;
  z-index: 6;
  height: 80px;

  &__container {
    height: 80px;
    justify-content: space-between;
  }

  &__logo {
    display: block;
    width: auto;
    height: 2.4rem;
    margin-bottom: 1rem;
  }

  &__switch {
    @include not-desktop {
      display: none;
    }
  }

  &__nav {
    @include not-desktop {
      display: none;
    }

    @include desktop {
      display: flex;
      flex-grow: 1;
      justify-content: space-between;
    }

    &.hidden {
      @include desktop {
        display: none;
      }
    }
  }

  &__progress {
    margin: 0 auto;

    @include mobile {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
    }

    @include tablet {
      width: 500px;
    }

    @include tablet-only {
      @media (orientation: portrait) {
        width: 340px;
      }
    }
  }

  &__login {
    @include not-desktop {
      margin-left: auto;
    }
  }

  &__mobile-menu {
    @include not-desktop {
      margin-left: 20px;
    }

    @include desktop {
      display: none !important;
    }
  }

  &__flow {
    margin: auto;
    display: flex;

    @include not-desktop {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      font-size: 0;
    }

    @include desktop {
      padding: 0 40px;
      flex-grow: 1;
      justify-content: center;
    }
  }

  &__step {
    white-space: nowrap;
    font-weight: 600;
    border-top: 2px solid map-get($colors, text-light);
    color: map-get($colors, text-light);
    flex-grow: 1;

    @include not-desktop {
      border-top-width: 5px;
    }

    @include desktop {
      margin-right: 15px;
      padding-top: 5px;
      font-size: 14px;

      &:last-child {
        margin: 0;
      }
    }

    &.active {
      border-color: map-get($colors, secondary);
      color: map-get($colors, secondary);
    }
  }
}

.drawer {
  &__switch {
    margin: 20px 30px 10px;
  }

  &__profile {
    padding: 20px 30px;
    border-bottom: 1px solid map-get($colors, border);
  }

  &__nav {
    padding: 20px 30px;
  }

  &__contacts {
    padding: 20px 30px;
    margin-top: auto;

    a {
      display: block;
      color: map-get($colors, text);
    }
  }
}
</style>
